module.exports = __webpack_public_path__ + "static/media/table-blue-9-ball.edd230cb.png";